<template>
  <div class="page-title">
    <div>
      <h1 v-if="icon"><i :class="icon"></i> {{ main }}</h1>
      <h1 v-else><img :src="require(`@/assets/${imagem}`)" /> {{ main }}</h1>
    </div>
    <h2 v-if="sub && sub.length > 0" style="margin-left: 58px;">{{ sub }}</h2>
    <hr />
  </div>
</template>

<script>
export default {
  name: "PageTitle",
  props: ["icon", "main", "sub", "imagem"],
};
</script>

<style scoped>
.page-title h1 {
  margin: 0px;
  font-size: 2rem;
}

.page-title h2 {
  color: #777;
  margin-top: 5px;
  font-size: 1.1rem;
}

.page-title>hr{
  margin: 8px;
}

img {
  max-height: 35px;
}

@media only screen and (max-width: 537px) {
  .page-title > h1 {    
    font-size: 1.5rem;
  }

  .page-title > h2 {    
    font-size: 1rem;
  }

  img {
    max-height: 25px;
  }
}

</style>
